import { headers, dataTypes } from 'constants/tableColumns';

export const detailedViewTable = [
    {
        i: 1,
        w: '11%',
        th: headers.tradeDate,
        prop: 'tradeDate',
        type: dataTypes.string
    },
    {
        i: 2,
        w: '11%',
        th: headers.rmRegion,
        prop: 'rmRegion',
        type: dataTypes.string
    },
    {
        i: 3,
        w: '11%',
        th: headers.rmGroup,
        prop: 'rmGroup',
        type: dataTypes.string
    },
    {
        i: 4,
        w: '11%',
        th: headers.rm,
        prop: 'rm',
        type: dataTypes.string
    },
    {
        i: 5,
        w: '11%',
        th: headers.portfolioId,
        prop: 'portfolioId',
        type: dataTypes.string
    },
    {
        i: 6,
        w: '11%',
        th: headers.revenue,
        prop: 'revenue',
        type: dataTypes.number,
        subType: dataTypes.currency
    },
    {
        i: 7,
        w: '11%',
        th: headers.netDelta,
        prop: 'netDelta',
        type: dataTypes.number,
        subType: dataTypes.currency
    },
    {
        i: 8,
        w: '11%',
        th: headers.pnl,
        prop: 'pnl',
        type: dataTypes.number,
        subType: dataTypes.currency
    },
    {
        i: 9,
        w: '9.2%',
        th: headers.marketValue,
        prop: 'marketValue',
        type: dataTypes.number,
        subType: dataTypes.currency
    }
];
